var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4707 5.66202C14.1444 5.76308 17.0394 7.30866 19.1378 10.3344C19.2448 10.489 19.2567 10.6019 19.1437 10.7624C17.4376 13.271 15.1074 14.8582 12.1113 15.2981C7.76589 15.9342 4.32401 14.341 1.76786 10.7981C1.63708 10.6138 1.63113 10.489 1.76191 10.2928C3.52744 7.71883 5.95875 6.20297 9.04991 5.7393C9.2758 5.70363 9.50764 5.67391 9.73353 5.66202C9.97726 5.65013 10.2269 5.66202 10.4707 5.66202ZM10.4647 7.42755C8.75863 7.42161 7.32599 8.82452 7.31411 10.5128C7.30222 12.2248 8.69918 13.6634 10.3815 13.6753C12.1351 13.6871 13.5559 12.2961 13.5618 10.5603C13.5678 8.86018 12.1589 7.43349 10.4647 7.42755Z",
    fill: "#AAABAB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4451,
    cy: 10.546,
    rx: 1.773,
    ry: 1.773,
    fill: "#AAABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewers);
export default __webpack_public_path__ + "static/media/viewers.e9d73348f0159e5660e9e84c5170c256.svg";
export { ForwardRef as ReactComponent };